import { useMemo } from 'react';
import { useSelector } from 'react-redux';

export const useTimeFormat = () => {
    const settingsData = useSelector((state) => state.settings.data);
    return useMemo(() => {
        const timeFormat = settingsData?.shop?.remove_am_pm ? 'HH:mm' : 'hh:mm a';
        return timeFormat;
    }, [settingsData]);
};